import React, {useContext, useState, useEffect, useReducer} from 'react';
import { useNavigate } from 'react-router-dom'; 
import useApi from '../Hooks/useApi'
import Loader from '../Components/Loader'
import utilities from '../utilities'
import SelectControl from '../Components/SelectControl';
import {AuthContext} from '../context/AuthContext'
import swal from 'sweetalert'


const Applications = (props) => {

    const {userInfo} = useContext(AuthContext);
    const navigate = useNavigate();
    const[selectedCategory, setSelectedCategory] = useState(0);
    //const[data, setData] = useState(null);
    const[showLoader, setShowLoader]= useState(false);
    const {data} = useApi( {url: '/Registration/GetApplications', method: 'get' });


const [, forceUpdate] = useReducer(x => x + 1, 0);

//const {connection} = useSignalR();



// if (connection)
// {
//     connection.on("FeePaidNotification", (message) => {
//         alert(message);
//     });    
// }

//const {data} = useApi( {url: '/Exam/DisplayRegularStudentsForExam', method: 'get' });

const {data: categories} = useApi( {url: '/Registration/GetInstituteCategories', method: 'get' });



// useEffect(() => {
//     if (connection)
//     {
//       console.log('SignalR Connection ID Established: ' + connection.connection.connectionId);
//     }
//   }, [connection])

  
//const navigate = useNavigate();

//   useEffect(() => {
//     if (userInfo.jwt)
//     {
//       navigate('/exam/students');
//     }
// }, [userInfo])




// function getObjects(obj, key, val) {
//     var objects = [];
//     for (var i in obj) {
//         if (!obj.hasOwnProperty(i)) continue;
//         if (typeof obj[i] == 'object') {
//             objects = objects.concat(getObjects(obj[i], key, val));
//         } else if (i == key && obj[key] == val) {
//             objects.push(obj);
//         }
//     }
//     return objects;
// }


// function setUserName(studentID, yearID, category, newVal){
    
//     let index = data[yearID]["category"].find(_category => _category.name === category)["students"].findIndex(_student => _student["studentID"] == studentID);
//     if (index == -1)
//     {
//         alert('not exists');
//     }
//     else
//     {
//         data[yearID]["category"].find(_category => _category.name === category)["students"][index]["studentName"]= newVal;
//         forceUpdate();
//     }
// }

const handleCategoryChange = (e) => {
    //setShowLoader(true);
    //var categoryID = e.target.value;
    //setSelectedCategory(categoryID);
    //utilities.getData( {url: '/Registration/GetApplications?CategoryID=' + categoryID, jwt: userInfo.jwt}).then(student => {
    //    setData(student);
    //    setShowLoader(false);
    //})
}

const EditApplication = (candidateID) => {
    var registrationID = utilities.encryptData(candidateID.toString());
    navigate('/registration/application/' + registrationID );   
  }

  const GenerateChallan = async (regID) => {
    var challanNo = await utilities.getAsyncData( {url: '/Registration/GenerateChallan?RegistrationID=' + regID  , jwt: userInfo.jwt} );
    var encryptedChallan = utilities.encryptData(challanNo.toString());
    navigate('/registration/payment/' + encryptedChallan);  
  }

  const UploadVerification = (regID) => {
    var registrationID = utilities.encryptData(regID.toString());
    navigate('/registration/verification/' + registrationID );   
  }

  const DeleteApplication = async (regID, category) => {

    swal({
        title: "Are you sure ?",
        text: "Registration Application will be deleted permanently", 
        icon: "warning",
        buttons: true,
        dangerMode: true,
    })
    .then( async (willDelete) =>  {
      if (willDelete) {
        var isDeleted = await utilities.getAsyncData( {url: '/Registration/DeleteApplication?RegistrationID=' +regID  , jwt: userInfo.jwt} );
        if (isDeleted)
        {
            let index = data.find(_category => _category.name === category)["students"].findIndex(_student => _student["registrationID"] === regID);//
             data.find(_category => _category.name === category)["students"].splice(index, 1);
             forceUpdate();
              swal("Deleted", "Application Deleted Successfully", {
                icon: "error",
              });

        }
        else
        {
            swal("Error", "An error has been occured...", {
                icon: "error",
              });
        }
      } else {
        swal("Cancelled", "Delete action has been cancelled", {
            icon: "error",
          });
      }
    });
    
    


  }

  


  return (
    <>

<div className="content">
    <div className="header">
        <label className="title"> Submitted Applications </label>
    </div>

{/* {!categories ? (<Loader />) : (
    <select name="CategoryID" className='form-select' style={{maxWidth: '450px'}} value={selectedCategory } onChange={e => handleCategoryChange(e)}>
        <option value="0">--Select Category--</option>
        {categories?.map((category, key) => {
            return (
                <option value={category.categoryID} key={category.categoryID} >{category.categoryName}</option>
            )})
        }
    </select>
)} */}


{/* {showLoader ? (<Loader />) : ( <></>
)} */}

    {!data ? (<Loader />) : (

    
                                <div className="body">
                                    <div className="animate-bottom">
                                                    {data.map((category, index) => {
                                                        return (
                                                            <div className="table-responsive" > 
                                                            <table className='table table-striped table-hover table-bordered caption-top'>
                                                                <caption >
                                                                    <span key={index}> {category.name} </span>
                                                                </caption>
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>Session</th>
                                                                        <th>Student Name</th>
                                                                        <th>Father Name</th>
                                                                        <th>CNIC</th>
                                                                        <th>Category</th>
                                                                        <th>Fee Status</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                
                                                                <tbody>

                                                                {category.students.map((student, i) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={student.studentID}>
                                                                                <td>{student.session}</td>
                                                                                <td>{student.studentName}</td>
                                                                                <td>{student.fatherName}</td>
                                                                                <td>{student.cnic}</td>
                                                                                <td>{student.category}</td>
                                                                                { student.isFeePaid ? <span className='text-success'>Fee Paid</span> :  <span className='text-danger'> Not Paid</span> }
                                                                                
                                                                                <td style={{textAlign: 'center'}}> 

                                                                                    
                                                                                {!userInfo.isPortalLocked && !student.isFeePaid && !student.isOnlineAdmission? (
                                                                                    <>
                                                                                        <button className='btn btn-sm btn-outline-primary' onClick={() => EditApplication(student.registrationID)} > Edit </button> 
                                                                                        <button className='btn btn-sm btn-outline-danger ms-2' onClick={() => DeleteApplication(student.registrationID, student.category)} > Delete </button> 
                                                                                    </>
                                                                                ): (null)}
                                                                                
                                                                                {/* 
                                                                                {!userInfo.isPortalLocked && student.isFeePaid ? (
                                                                                    <>
                                                                                        <button className='btn btn-sm btn-outline-danger ms-2' onClick={() => DeleteApplication(student.registrationID, student.category)} > Delete </button> 
                                                                                    </>
                                                                                ): (null)} */}


                                                                                {!userInfo.isPortalLocked && !student.isFeePaid ? (<button className='btn btn-sm btn-outline-primary ' onClick={() => GenerateChallan(student.registrationID)} > Fee Challan </button>) : null}
                                                                                {/* {!userInfo.isFeePeriodExpired && !student.isFeePaid ? (<button className='btn btn-sm btn-outline-primary ' onClick={() => GenerateChallan(student.registrationID)} > Fee Challan </button>) : null} */}
                                                                                {!userInfo.isObjectionRemovalPeriodExpired && !student.matricVerificationPath  ? (<button className='btn btn-sm btn-outline-primary ms-2' onClick={() => UploadVerification(student.registrationID)} > Upload Verification </button>) : null} 
                                                                                <button className='btn btn-sm btn-outline-primary ms-2' onClick={() => EditApplication(student.registrationID)} > View Application </button>                                                                                                                                                                      

                                                                                
                                                                                </td>


                                                                            </tr>
                                                                        </>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                        </table>
                                                        </div>
                                                        );

                                                    })
                                                    }

                                    </div>


                                    
                                </div>
        )
    }
                                </div>

    </>
  );

};

export default Applications;